/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1238
 */

var r = require(/* 194 */"../1648/194")
var o = require(/* 1079 */"../1686/1079/index")
var /* [auto-meaningful-name] */r$WeakMap = r.WeakMap
module.exports = "function" === typeof r$WeakMap && /native code/.test(o(r$WeakMap))
